/* eslint-disable */
// Gender-based image resolver for the HairstyleWomen funnel.
// Images live in assets/images/hairstyle-women/{male,female,default}/ (+ hero/).
// require.context reads whatever is present at build time, so the images the
// designer adds later don't need any code change — and MISSING files never
// break the build; the component just falls back to a gradient placeholder.

export type ImageTrack = 'male' | 'female' | 'default';

// @ts-ignore — webpack require.context
const ctx = (require as any).context('../../../assets/images/hairstyle-women', true, /\.(png|jpe?g|webp|svg)$/);

const stripExt = (s: string) => s.replace(/\.(png|jpe?g|webp|svg)$/i, '');

// keyed by extension-less path, e.g. 'male/value-1' → url, so .jpg/.png/.webp all match
const byKey: Record<string, string> = {};
ctx.keys().forEach((k: string) => {
  const clean = stripExt(k.replace(/^\.\//, '')); // './male/value-1.jpg' → 'male/value-1'
  byKey[clean] = ctx(k);
});

/** male/female → own track, anything else (incl. "Prefer not to say") → default. */
export function trackFromGender(g?: string): ImageTrack {
  return g === 'male' || g === 'female' ? g : 'default';
}

/** Resolve an asset by track+name (extension optional), e.g. img('male','value-1'). undefined if absent. */
export function img(track: ImageTrack, name: string): string | undefined {
  const key = stripExt(name);
  return byKey[`${track}/${key}`] ?? byKey[`default/${key}`];
}

/** Hero art (shown before gender is chosen). undefined until the designer adds it. */
export function heroImg(name = 'hero'): string | undefined {
  return byKey[`hero/${stripExt(name)}`];
}

/** UI icon from hairstyle-women/icons/ (e.g. icon('head-side')). undefined until the file is added. */
export function icon(name: string): string | undefined {
  return byKey[`icons/${stripExt(name)}`];
}

/** Review photo from hairstyle-women/reviews/ (e.g. reviewImg('review-1-man')). undefined until added. */
export function reviewImg(name: string): string | undefined {
  return byKey[`reviews/${stripExt(name)}`];
}
